import React from 'react';
import { Disclaimer } from './Disclaimer';

export const AgentBenefitsDisclaimer = () => {
  return <Disclaimer resource={'state-farm-disclaimer.onboarding.benefits'} />;
};
